import MapData from './MapData';

export default MapData;
